module.exports = __webpack_public_path__ + "static/media/card4_7.1034c3a8.png";